import React from 'react';
import { Box } from '@mui/material';
import PublicNavbar from './PublicNavbar';
import Footer from './Footer';
import PageTransition from './PageTransition';
import BackToTop from './BackToTop';

const PublicRoute = ({ children }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <PublicNavbar />

      <Box component="main" sx={{
        flexGrow: 1,
        width: '100%'
      }}>
        <PageTransition>{children}</PageTransition>
      </Box>
      <Footer />
      <BackToTop />
    </Box>
  );
};

export default PublicRoute;